import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/common/ErrorBoundary';
import logger from './utils/logger';
import packageJson from '../package.json';
import { loadUiScale, applyUiScale } from './utils/uiScale';

// Apply the saved (or default 80%) display scale before first paint so the app renders at the
// correct zoom immediately — on the login screen and after login, with no 100%→80% flash.
applyUiScale(loadUiScale());

// One structured startup line. No PII (the resolved user is logged later by PermissionContext
// without identifiers). authMode here is the CONFIGURED mode known at boot, not the resolved one.
const authMode =
  process.env.REACT_APP_DEV_BYPASS_AUTH === 'true'
    ? 'dev-bypass'
    : (sessionStorage.getItem('keycloakToken') ? 'keycloak' : 'azure_ad');
logger.info('App starting', {
  event: 'app_start',
  name: process.env.NODE_ENV,
  url: process.env.REACT_APP_API_URL,
  method: authMode,
  code: process.env.REACT_APP_VERSION || packageJson.version,
});

// Global handlers for errors the React ErrorBoundary can't catch (async / event handlers /
// unhandled promise rejections). Log message only — never the full event/reason object.
window.addEventListener('error', (event) => {
  logger.error('Uncaught error', { message: event?.message });
});
window.addEventListener('unhandledrejection', (event) => {
  const reason = event?.reason;
  logger.error('Unhandled promise rejection', {
    message: reason?.message || (typeof reason === 'string' ? reason : 'Unhandled rejection'),
  });
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
